export const decisioningStudioAgentsAppGroupIdDsaIdTiming =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing";
